import React, { memo } from 'react';
import { Modal, Typography, Icon } from '@ann/web-components';
import {
  ModalHeaderContainer,
  ModalContentContainer,
  ItemWrapper,
} from './DeleteDocumentModal.styled';

const getFileIcon = (type, extension) => {
  const ext = extension?.toLowerCase() || type?.toLowerCase() || '';
  if (ext.includes('pdf')) return 'pictureAsPdf';
  if (ext.includes('doc') || ext.includes('word')) return 'description';
  if (ext.includes('xls') || ext.includes('excel')) return 'tableChart';
  if (ext.includes('ppt') || ext.includes('presentation')) return 'slideshow';
  return 'description';
};

const DeleteDocumentModal = ({
  isOpen,
  onClose,
  onConfirm,
  document,
  isLoading = false,
}) => {
  const handleConfirm = async () => {
    await onConfirm?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="medium" width="571px">
      <Modal.Header />
      <ModalHeaderContainer>
        <Typography category="title" size="medium" weight="bold">
          Are you sure you want to delete this file?
        </Typography>
      </ModalHeaderContainer>
      <Modal.Body>
        <ModalContentContainer>
          <Typography category="body" size="medium" weight="regular" color="body">
            This action will unassign the selected file from your agent's knowledge base and soft delete it.
          </Typography>
          {document && (
            <ItemWrapper>
              <Icon name={getFileIcon(document.type, document.extension)} />
              <Typography category="body" size="medium" weight="regular" color="body">
                {document.name || 'Unnamed Document'}
              </Typography>
            </ItemWrapper>
          )}
        </ModalContentContainer>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button 
          label="Cancel" 
          onClick={onClose} 
          type="secondary" 
          disabled={isLoading} 
        />
        <Modal.Button
          label={isLoading ? 'Deleting...' : 'Delete'}
          onClick={handleConfirm}
          disabled={isLoading}
        />
      </Modal.Actions>
    </Modal>
  );
};

DeleteDocumentModal.displayName = 'DeleteDocumentModal';

export default memo(DeleteDocumentModal);

